<div class="text-right"><span class="close" (click)="close()">
    <mat-icon>close</mat-icon>
</span></div>
<div class="manual-wrapper">
<ngx-extended-pdf-viewer src="../../../../../assets/files/Упатство за користење на Платформата за Лојалност од страна на Партнер Администратор.pdf" useBrowserLocale="true">
</ngx-extended-pdf-viewer>
</div>